import {NgIf} from '@angular/common';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, ViewChild} from '@angular/core';
import {NbIconModule} from '@nebular/theme';
import {CompoApiService} from 'compob2b-libs';
import {SafeUrl} from '@angular/platform-browser'

@Component({
  standalone: true,
  selector: 'app-secured-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div #trigger class="secured-img-container">
      <ng-container *ngIf="blob; else loader">
        <img [src]="blob" alt=""/>
      </ng-container>

      <ng-template #loader>
        <nb-icon icon="loader-outline"/>
      </ng-template>
    </div>
  `,
  imports: [
    NgIf,
    NbIconModule,
  ],
  styleUrls: ['secured-image.component.scss']
})
export class SecuredImageComponent {
  @Input() src: string;
  @ViewChild('trigger') trigger!: any;

  loaded = false;
  blob: SafeUrl;
  observer: IntersectionObserver;
  cdr = inject(ChangeDetectorRef);
  compoApiService = inject(CompoApiService);

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !this.loaded) {
        this.loaded = true;
        this.loadImage();
      }
    }, {
      threshold: 0.1,
      rootMargin: '50px' // предзагрузка за 50px до вьюпорта
    });

    // Начинаем наблюдение после инициализации view
    this.observer.observe(this.trigger.nativeElement);
  }

  private loadImage() {
    this.compoApiService.getDocumentImageBlob(this.src).subscribe((blob) => {
      this.blob = blob;
      this.loaded = true;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
